<cr-panel fxFlex>
	<cr-panel-header>
		<label [matTooltip]="preview?.title" class="suspect-title">
			{{ preview?.title || translates?.SUSPECT_SECTION?.TITLE || 'Suspect' }}
		</label>
	</cr-panel-header>

	<cr-panel-actions>
		<cr-panel-action fxHide.lt-md *ngIf="!isHtml">
			<ng-container *ngTemplateOutlet="menu__align_left"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md *ngIf="!isHtml">
			<ng-container *ngTemplateOutlet="menu__align_right"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md *ngIf="!isHtml">
			<ng-container *ngTemplateOutlet="menu__font_inc"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md *ngIf="!isHtml">
			<ng-container *ngTemplateOutlet="menu__font_dec"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md>
			<ng-container *ngTemplateOutlet="menu__toggle_html"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.lt-md *ngIf="hasUrl">
			<ng-container *ngTemplateOutlet="menu__launch_url"></ng-container>
		</cr-panel-action>
		<cr-panel-action fxHide.gt-sm *ngIf="isMobile">
			<button mat-button [matMenuTriggerFor]="appMenu" aria-label="More Options">
				<mat-icon svgIcon="more_vert"></mat-icon>
			</button>
		</cr-panel-action>
		<cr-panel-action *ngIf="!disableBackButton">
			<ng-container *ngTemplateOutlet="menu__show_results"></ng-container>
		</cr-panel-action>
	</cr-panel-actions>

	<cr-panel-body fxLayout="column nowrap">
		<div fxFlex fxLayout="column" fxLayoutGap="1em">
			<div card fxFlex class="mat-elevation-z3" fxLayout="column">
				<!-- skeleton placeholder -->
				<ng-container *ngTemplateOutlet="!suspect ? skeleton__body : null"></ng-container>
				<!-- text for one-to-one -->
				<div
					[fxShow]="suspect && !(hasHtml && isHtml)"
					crSuspectTextHelper
					[host]="this"
					text-container
					[ngStyle]="{ 'font-size': zoom + 'em' }"
					[dir]="direction">
					<ng-container *ngIf="textMatches; else clean">
						<ng-container *ngFor="let partial of textMatches[currentPage - 1]">
							<span *ngIf="partial.match.type === MatchType.none">{{ partial.content }}</span>
							<span *ngIf="partial.match.type !== MatchType.none" [cr-match]="partial.match" origin="suspect">
								{{ partial.content }}
							</span>
						</ng-container>
					</ng-container>
				</div>
				<!-- text without match highlighting -->
				<ng-template #clean>
					{{ suspect && (suspect.text.value | slice : pages[currentPage - 1] : pages[currentPage]) }}
				</ng-template>

				<iframe
					sandbox="allow-scripts"
					title="Document"
					fxFlex
					[fxShow]="hasHtml && isHtml"
					cr-suspect-html-helper></iframe>
			</div>
		</div>

		<div content-footer fxLayoutAlign="space-between center" fxLayout="row-reverse nowrap">
			<ng-container *ngIf="suspect; else skeleton__pagination">
				<cr-mat-pagination
					[hidden]="(hasHtml && isHtml) || pages?.length === 1"
					showFirstLastButtons
					[currentPage]="currentPage"
					(page)="onPage($event)"
					[totalPages]="pages.length"></cr-mat-pagination>
			</ng-container>
			<cr-powered-by></cr-powered-by>
		</div>
	</cr-panel-body>
</cr-panel>

<ng-template #skeleton__pagination>
	<div fxLayout="row nowrap" fxLayoutGap="0.5em" fxLayoutAlign="start stretch">
		<ngx-skeleton-loader [theme]="{ width: '36px', height: '36px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '36px', height: '36px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '200px', height: '36px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '36px', height: '36px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '36px', height: '36px' }"></ngx-skeleton-loader>
	</div>
</ng-template>

<!-- menu -->

<!-- menu -->
<mat-menu #appMenu>
	<!-- <button mat-menu-item
					crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__next_match"></ng-container>
		{{translates?.SHARED?.ACTIONS?.GO_TO_NEXT_MATCH || 'Next Match'}}
	</button>
	<button mat-menu-item
					crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__prev_match"></ng-container>
		{{translates?.SHARED?.ACTIONS?.GO_TO_PREV_MATCH || 'Previous Match'}}
	</button> -->
	<button mat-menu-item *ngIf="hasUrl" (click)="openUrl()" crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__launch_url"></ng-container>
		{{ translates?.SHARED?.ACTIONS?.LAUNCH_URL || 'Open URL in a new tab' }}
	</button>
	<button mat-menu-item (click)="toggleContent()" crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__toggle_html"></ng-container>
		{{
			isHtml
				? translates?.SHARED?.ACTIONS?.SWITCH_TO_TEXTUAL_MODE || 'Switch to textual mode'
				: translates?.SHARED?.ACTIONS?.SWITCH_TO_RICH_TEXT_MODE || 'Switch to rich text mode'
		}}
	</button>
	<button mat-menu-item *ngIf="!isHtml" crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__align_left"></ng-container>
		{{ translates?.SHARED?.ACTIONS?.ALIGN_LEFT || 'Align Left' }}
	</button>
	<button mat-menu-item *ngIf="!isHtml" crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__align_right"></ng-container>
		{{ translates?.SHARED?.ACTIONS?.ALIGN_RIGHT || 'Align Right' }}
	</button>
	<button mat-menu-item *ngIf="!isHtml" (click)="increaseFontSize()" crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__font_inc"></ng-container>
		{{ translates?.SHARED?.ACTIONS?.INCREASE_FONT_SIZE || 'Increase Font Size' }}
	</button>
	<button mat-menu-item *ngIf="!isHtml" (click)="decreaseFontSize()" crClickStopPropagation>
		<ng-container *ngTemplateOutlet="menu__font_dec"></ng-container>
		{{ translates?.SHARED?.ACTIONS?.DECREASE_FONT_SIZE || 'Decrease Font Size' }}
	</button>
</mat-menu>
<ng-template #menu__next_match>
	<button
		mat-button
		[matTooltip]="translates?.SHARED?.ACTIONS?.GO_TO_NEXT_MATCH || 'Go to next match'"
		aria-label="Go to next match.">
		<mat-icon svgIcon="arrow_downward"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__prev_match>
	<button
		mat-button
		[matTooltip]="translates?.SHARED?.ACTIONS?.GO_TO_PREV_MATCH || 'Go to previous match'"
		aria-label="Go to previous match.">
		<mat-icon svgIcon="arrow_upward"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__toggle_html>
	<button
		role="button"
		mat-button
		[matTooltip]="
			hasHtml
				? isHtml
					? translates?.SHARED?.ACTIONS?.SWITCH_TO_TEXTUAL_MODE || 'Switch to textual mode'
					: translates?.SHARED?.ACTIONS?.SWITCH_TO_RICH_TEXT_MODE || 'Switch to rich text mode'
				: 'No HTML version was found for this report'
		"
		[disabled]="!hasHtml"
		(click)="toggleContent()"
		aria-label="Switch report to text mode or rich text mode.">
		<ng-container *ngIf="hasHtml">
			<mat-icon [svgIcon]="isHtml ? 'title' : 'insert_photo'"></mat-icon>
		</ng-container>
		<ng-container *ngIf="!hasHtml">
			<mat-icon>{{ isHtml ? 'title' : 'insert_photo' }}</mat-icon>
		</ng-container>
	</button>
</ng-template>
<ng-template #menu__align_left>
	<button
		mat-button
		[matTooltip]="translates?.SHARED?.ACTIONS?.ALIGN_LEFT || 'Align left'"
		(click)="direction = 'ltr'"
		aria-label="Align content to left.">
		<mat-icon svgIcon="format_align_left"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__launch_url>
	<button
		mat-button
		[matTooltip]="translates?.SHARED?.ACTIONS?.LAUNCH_URL || 'Open URL in a new tab'"
		(click)="openUrl()"
		aria-label="Opens the result source link in a new tab.">
		<mat-icon svgIcon="launch"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__align_right>
	<button
		mat-button
		[matTooltip]="translates?.SHARED?.ACTIONS?.ALIGN_RIGHT || 'Align right'"
		(click)="direction = 'rtl'"
		aria-label="Align content to right.">
		<mat-icon svgIcon="format_align_right"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__font_inc>
	<button
		mat-button
		[matTooltip]="translates?.SHARED?.ACTIONS?.INCREASE_FONT_SIZE || 'Increase font size'"
		(click)="increaseFontSize()"
		aria-label="Increase font size.">
		<mat-icon svgIcon="zoom_in"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__font_dec>
	<button
		mat-button
		[matTooltip]="translates?.SHARED?.ACTIONS?.DECREASE_FONT_SIZE || 'Decrease font size'"
		(click)="decreaseFontSize()"
		aria-label="Decrease font size.">
		<mat-icon svgIcon="zoom_out"></mat-icon>
	</button>
</ng-template>
<ng-template #menu__show_results>
	<button
		mat-button
		[matTooltip]="translates?.SHARED?.ACTIONS?.CLOSE || 'Close'"
		(click)="goBack()"
		aria-label="Go back to all results view.">
		<mat-icon svgIcon="close"></mat-icon>
	</button>
</ng-template>

<!-- skeletons -->
<ng-template #skeleton__body>
	<div
		fxFlex
		fxLayout="column"
		fxLayoutAlign="start stretch"
		fxLayoutGap="1em"
		style="overflow: hidden; margin: 1em"
		skeleton__body>
		<ngx-skeleton-loader [theme]="{ height: '100%' }" *ngFor="let item of 20 | array; index as i"></ngx-skeleton-loader>
	</div>
</ng-template>
